module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Upload-folder-3b4a508ad228bf407df2df14a173a6c8.svg";